import React from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export function KpiCard({
    label,
    value,
    hint,
    trend,
    trendDirection = "flat",
    icon: Icon,
    accent = "blue",
    testId,
}) {
    const accents = {
        blue: "text-[#2563EB] bg-[#2563EB]/10",
        green: "text-[#16A34A] bg-[#16A34A]/10",
        amber: "text-[#F59E0B] bg-[#F59E0B]/10",
        red: "text-[#DC2626] bg-[#DC2626]/10",
        slate: "text-[#64748B] bg-slate-100",
    };
    const TrendIcon = trendDirection === "up" ? TrendingUp : trendDirection === "down" ? TrendingDown : Minus;
    const trendColor =
        trendDirection === "up" ? "text-[#16A34A]" :
            trendDirection === "down" ? "text-[#DC2626]" : "text-[#64748B]";

    return (
        <div
            data-testid={testId || `kpi-${label}`}
            className="bg-white border border-[#DCE3EE] rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow duration-200"
        >
            <div className="flex items-start justify-between">
                <div>
                    <p className="text-xs font-semibold text-[#64748B] uppercase tracking-wider">{label}</p>
                    <p className="text-3xl font-bold text-[#172033] mt-3 tabular-nums">{value}</p>
                    {hint && <p className="text-xs text-[#64748B] mt-1">{hint}</p>}
                </div>
                {Icon && (
                    <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${accents[accent]}`}>
                        <Icon className="w-5 h-5" strokeWidth={2} />
                    </div>
                )}
            </div>
            {trend !== undefined && trend !== null && (
                <div className={`flex items-center gap-1 mt-4 text-xs font-medium ${trendColor}`}>
                    <TrendIcon className="w-3.5 h-3.5" />
                    <span>{trend}</span>
                </div>
            )}
        </div>
    );
}

export default KpiCard;
